import { css } from '@linaria/core';

const starRatingLabel = css``;

const starRatingIconContainer = css`
  gap: 2px;
  display: flex;
`;

const thermometer = css`
  font-size: 1.25em;
`;

const starRatingIcon = css`
  letter-spacing: -5px;
  font-size: 0.9em;
`;

const starRatingRoot = css`
  display: inline-flex;
  gap: 4px;
  align-items: center;
`;

export default {
  root: starRatingRoot,
  label: starRatingLabel,
  iconsContainer: starRatingIconContainer,
  icon: starRatingIcon,
  thermometer,
};
